__turbopack_context__.v({
  "brandSection": "DashboardHeader-module__V5JXYa__brandSection",
  "container": "DashboardHeader-module__V5JXYa__container",
  "content": "DashboardHeader-module__V5JXYa__content",
  "header": "DashboardHeader-module__V5JXYa__header",
  "headerCompact": "DashboardHeader-module__V5JXYa__headerCompact",
  "ivueitPhotoIconSvg": "DashboardHeader-module__V5JXYa__ivueitPhotoIconSvg",
  "ivueitPhotoIconWrap": "DashboardHeader-module__V5JXYa__ivueitPhotoIconWrap",
  "ivueitPhotoLink": "DashboardHeader-module__V5JXYa__ivueitPhotoLink",
  "ivueitPhotoText": "DashboardHeader-module__V5JXYa__ivueitPhotoText",
  "logoContainer": "DashboardHeader-module__V5JXYa__logoContainer",
  "logoImage": "DashboardHeader-module__V5JXYa__logoImage",
  "logoText": "DashboardHeader-module__V5JXYa__logoText",
  "manageRequestsAvatar": "DashboardHeader-module__V5JXYa__manageRequestsAvatar",
  "manageRequestsContainer": "DashboardHeader-module__V5JXYa__manageRequestsContainer",
  "manageRequestsIconSvg": "DashboardHeader-module__V5JXYa__manageRequestsIconSvg",
  "manageRequestsText": "DashboardHeader-module__V5JXYa__manageRequestsText",
  "profileAvatar": "DashboardHeader-module__V5JXYa__profileAvatar",
  "profileChevron": "DashboardHeader-module__V5JXYa__profileChevron",
  "profileChevronOpen": "DashboardHeader-module__V5JXYa__profileChevronOpen",
  "profileContainer": "DashboardHeader-module__V5JXYa__profileContainer",
  "profileDropdown": "DashboardHeader-module__V5JXYa__profileDropdown",
  "profileDropdownItem": "DashboardHeader-module__V5JXYa__profileDropdownItem",
  "profileDropdownItemActive": "DashboardHeader-module__V5JXYa__profileDropdownItemActive",
  "profileDropdownItemIcon": "DashboardHeader-module__V5JXYa__profileDropdownItemIcon",
  "profileDropdownWrap": "DashboardHeader-module__V5JXYa__profileDropdownWrap",
  "profileIconSvg": "DashboardHeader-module__V5JXYa__profileIconSvg",
  "profileText": "DashboardHeader-module__V5JXYa__profileText",
  "rightSection": "DashboardHeader-module__V5JXYa__rightSection",
  "signOutAvatar": "DashboardHeader-module__V5JXYa__signOutAvatar",
  "signOutContainer": "DashboardHeader-module__V5JXYa__signOutContainer",
  "signOutIconSvg": "DashboardHeader-module__V5JXYa__signOutIconSvg",
  "signOutText": "DashboardHeader-module__V5JXYa__signOutText",
});
